import dayjs from 'dayjs';

import { TIME } from '@cast/constants';
import { DataPopperRow, Typography, Stack, tokens } from '@cast/design-system';

import { ComputeSpendChartData } from 'features/cost-report/types/costOverTime';

type ComputeSpendTooltipProps = {
  payload: ComputeSpendChartData;
  timezone: string;
};

export const ComputeSpendAnomalyTooltip = ({
  payload,
  timezone,
}: ComputeSpendTooltipProps) => {
  if (!payload?.anomalies.length) {
    return null;
  }

  const multipleAnomalies = payload.anomalies.length > 1;

  const title = multipleAnomalies
    ? `${payload.anomalies.length} anomalies detected`
    : 'Cost Anomaly';

  return (
    <Stack data-testid="cost-report-anomaly-tooltip" sx={{ minWidth: 240 }}>
      <DataPopperRow
        left={
          <Typography
            color={multipleAnomalies ? 'red.600' : undefined}
            variant="L12B"
          >
            {title}
          </Typography>
        }
        dividerBottom={multipleAnomalies}
      />
      {!multipleAnomalies && (
        <DataPopperRow
          sx={{ mt: -12 }}
          left={
            <Typography color="red.600" variant="P10R">
              Anomaly
            </Typography>
          }
          dividerBottom
        />
      )}
      <DataPopperRow
        left={
          <Typography
            color={tokens.theme.fg.structural.secondary}
            variant="P12R"
          >
            Detected
          </Typography>
        }
        right={
          <Typography color="grey.700" variant="P12M">
            {dayjs
              .utc(payload.anomalies[0].timestamp)
              .tz(timezone)
              .format(TIME)}
          </Typography>
        }
      />
    </Stack>
  );
};
